import { plantHasDistinctPhoto } from "@/app/lib/plant-image";

interface PlantMarkLook {
  initial: string;
  color: string;
  labelImageUrl?: string | null;
}

interface PlantMarkInput {
  id: string;
  photoImageUrl?: string | null;
  species?: PlantMarkLook;
}

export interface SpeciesMarkInput {
  id?: string;
  initial: string;
  color: string;
}

const DEFAULT_LOOK: PlantMarkLook = { initial: "?", color: "oklch(0.55 0.09 145)", labelImageUrl: null };

export function PlantMark({ plant, size = 56 }: Readonly<{
  plant: PlantMarkInput;
  size?: number;
}>) {
  const look = plant.species ?? DEFAULT_LOOK;
  if (plantHasDistinctPhoto(plant)) {
    return (
      <img
        className="plant-mark block object-cover rounded-[10px]"
        style={{ width: size, height: size }}
        src={plant.photoImageUrl!}
        alt=""
      />
    );
  }
  const patternId = `stripe-${plant.id ?? look.initial}`;
  return (
    <div className="plant-mark rounded-[10px] overflow-hidden" style={{ width: size, height: size, background: look.color }}>
      <svg viewBox="0 0 56 56" width={size} height={size} aria-hidden="true">
        <defs>
          <pattern id={patternId} width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(35)">
            <rect width="6" height="6" fill="transparent" />
            <line x1="0" y1="0" x2="0" y2="6" stroke="rgba(255,255,255,.18)" strokeWidth="2" />
          </pattern>
        </defs>
        <rect width="56" height="56" fill={`url(#${patternId})`} />
        <text x="50%" y="54%" textAnchor="middle" dominantBaseline="middle"
          fontFamily="'Source Serif 4', serif" fontWeight="500" fontSize="26"
          fill="rgba(255,255,255,.95)" letterSpacing="-0.02em">
          {look.initial}
        </text>
      </svg>
    </div>
  );
}


export function SpeciesMark({ species, size = 56 }: Readonly<{
  species: SpeciesMarkInput;
  size?: number;
}>) {
  const look = species ?? DEFAULT_LOOK;
  const patternId = `stripe-${species.id ?? look.initial}`;
  return (
    <div className="plant-mark rounded-[10px] overflow-hidden" style={{ width: size, height: size, background: look.color }}>
      <svg viewBox="0 0 56 56" width={size} height={size} aria-hidden="true">
        <defs>
          <pattern id={patternId} width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(35)">
            <rect width="6" height="6" fill="transparent" />
            <line x1="0" y1="0" x2="0" y2="6" stroke="rgba(255,255,255,.18)" strokeWidth="2" />
          </pattern>
        </defs>
        <rect width="56" height="56" fill={`url(#${patternId})`} />
        <text x="50%" y="54%" textAnchor="middle" dominantBaseline="middle"
          fontFamily="'Source Serif 4', serif" fontWeight="500" fontSize="26"
          fill="rgba(255,255,255,.95)" letterSpacing="-0.02em">
          {look.initial}
        </text>
      </svg>
    </div>
  );
}
